/**
 * PlatformActivityStats
 *
 * Platform Activity section of the analytics dashboard.
 * Displays metrics for surveys, campaigns, templates, and other platform usage.
 */
import React from 'react';
import { 
  MessageSquare,
  BarChart3,
  Edit3,
  Download,
  Video,
  FileText,
  Clock
} from 'lucide-react';

const PlatformActivityStats = ({ analyticsData, formatNumber }) => {
  return (
    <div className="mb-8">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Platform Activity</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <div className="bg-white dark:bg-transparent border border-gray-200 dark:border-gray-700 rounded-lg p-4">
          <div className="flex items-center">
            <MessageSquare className="h-5 w-5 text-blue-600 mr-2" />
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Total Survey Videos</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">
                {formatNumber(analyticsData.platformStats?.totalSurveyVideos || 0)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-transparent border border-gray-200 dark:border-gray-700 rounded-lg p-4">
          <div className="flex items-center">
            <BarChart3 className="h-5 w-5 text-green-600 mr-2" />
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Total Campaigns</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">
                {formatNumber(analyticsData.platformStats?.totalCampaigns || 0)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-transparent border border-gray-200 dark:border-gray-700 rounded-lg p-4">
          <div className="flex items-center">
            <Edit3 className="h-5 w-5 text-purple-600 mr-2" />
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Template Usage</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">
                {formatNumber(analyticsData.platformStats?.totalTemplateEdits || 0)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-transparent border border-gray-200 dark:border-gray-700 rounded-lg p-4">
          <div className="flex items-center">
            <Download className="h-5 w-5 text-orange-600 mr-2" />
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Stock Video Downloads</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">
                {formatNumber(analyticsData.platformStats?.stockVideoDownloads || 0)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-transparent border border-gray-200 dark:border-gray-700 rounded-lg p-4">
          <div className="flex items-center">
            <Video className="h-5 w-5 text-red-600 mr-2" />
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Video Template Usage</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">
                {formatNumber(analyticsData.platformStats?.videoTemplateEdits || 0)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-transparent border border-gray-200 dark:border-gray-700 rounded-lg p-4">
          <div className="flex items-center">
            <FileText className="h-5 w-5 text-teal-600 mr-2" />
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Templates Edited</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">
                {formatNumber(analyticsData.platformStats?.totalTemplateEdits || 0)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-transparent border border-gray-200 dark:border-gray-700 rounded-lg p-4">
          <div className="flex items-center">
            <BarChart3 className="h-5 w-5 text-indigo-600 mr-2" />
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Total Template Page Hits</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">
                {formatNumber(analyticsData.platformStats?.totalTemplatePageHits || 0)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-transparent border border-gray-200 dark:border-gray-700 rounded-lg p-4">
          <div className="flex items-center">
            <Clock className="h-5 w-5 text-yellow-600 mr-2" />
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Pending Reviews</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">0</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformActivityStats;


